import { Button, Tooltip, Typography } from '@replai-platform/ui-components';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { CellData, GeneratedColumn, RequiredGeneratorParams } from '../../common';
import { RootState } from '../../../../store/rootReducer';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export type ReportDeleteTemplateAccessorType = {
  templateId: string;
  userId: string;
  onReportDeleteTemplateClick?: (setButtonLoading: React.Dispatch<React.SetStateAction<boolean>>) => void;
};

const ReportDeleteTemplateCellDecorator: React.FC<{
  cellData: ReportDeleteTemplateAccessorType;
}> = ({ cellData }) => {
  const userId = useSelector((state: RootState) => state.auth.id);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const button = useMemo(
    () => (
      <Button
        trailingIcon={{ name: buttonLoading ? 'LoadingCircle' : 'Trash2' }}
        onClick={() => {
          cellData?.onReportDeleteTemplateClick?.(setButtonLoading);
        }}
        disabled={buttonLoading}
        color="Warning"
        variant="text"
      />
    ),
    [cellData, buttonLoading, setButtonLoading]
  );

  if (!cellData) {
    return null;
  }

  return userId !== cellData.userId ? (
    <Tooltip
      placement="left"
      content={
        <Typography type="text-sm" fontWeight="medium" noMargin>
          Only the user who created a template can delete it
        </Typography>
      }
    >
      <ButtonContainer>
        <Button trailingIcon={{ name: 'Trash2' }} onClick={() => {}} disabled color="Warning" variant="text" />
      </ButtonContainer>
    </Tooltip>
  ) : (
    <ButtonContainer>{button}</ButtonContainer>
  );
};

function getReportDeleteColumn<T extends object = ReportDeleteTemplateAccessorType>({
  columnId,
  accessor,
}: RequiredGeneratorParams<T, ReportDeleteTemplateAccessorType>): GeneratedColumn<T> {
  return {
    id: columnId,
    accessor,
    Cell: (data: CellData<T, ReportDeleteTemplateAccessorType>) => (
      <ReportDeleteTemplateCellDecorator cellData={data?.cell?.value} />
    ),
  };
}

export default getReportDeleteColumn;
